import React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';

import { Header } from '../../container/header/header';
import { Legal } from '../../container/home/legal';
import { BackgroundImageHolder } from '../mama/page';
import { Winners } from './winners';

export const Page: React.FC<RouteComponentProps> = () => {
  return (
    <>
      <Layout>
        <BackgroundImageHolder>
          <Header />
          <Winners />
          <Legal />
        </BackgroundImageHolder>
      </Layout>
    </>
  );
};

const Layout = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  overflow-x: hidden;
`;